import { Component } from '@angular/core';

@Component({
  template: `<h1>404</h1><h3>Сторінку не знайдено</h3>`
})
export class NotFoundComponent { }
